import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@fontsource-variable/inter';
import '@xyflow/react/dist/base.css';
import '../presentation/design-system/tokens.css';
import '../presentation/design-system/base.css';
import '../presentation/quadro/quadro.css';
import '../presentation/licitacao/licitacao.css';
import '../presentation/acesso/acesso.css';
import { App } from './App';

createRoot(document.getElementById('raiz')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
